import React, {useState} from 'react'
import {Mutation} from "react-apollo";
import {LoginMutation} from "../apollo/mutations/LoginMutation";
import CiberAlerts from "../util/Messages";
import {Spinner} from "react-bootstrap";
import PasswordModal from "./PasswordModal";
import DocumentTypes from "./DocumentTypes";


class SignInForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      document: '',
      password: '',
      documentType: '',
      deviceId: "AFC" + Math.floor(Math.random() * ((999 - 100) + 1))
    };
  }

  handleChange = (e) => {
    if (e.label) {
      this.setState({
        documentType: e
      });
    }
    else {
      this.setState({
        [e.target.name]: e.target.value
      })
    }
  };

  setError(error) {
    this.setState({
      errorMessage: error
    });
  }

  render() {
    return (
      <Mutation mutation={LoginMutation}
        variables={{
          documentType: this.state.documentType.value,
          documentNumber: this.state.document,
          password: this.state.password,
          deviceId: this.state.deviceId
        }}
        onError={(error) => {
          this.setError(error)
        }}>
        {(loginForm, result) => {
          const {data, loading} = result;
          const [setShow] = useState(false);
          const handleShow = () => setShow(true);

          if (data && data.externalAuth && data.externalAuth.returnUrl) {
            window.location.replace(data.externalAuth.returnUrl)
          }

          return (<div className="card card-signin my-5 col-sm-6 border-left-0">
            
            <div className="card-body">
              <h1 className="card-title text-center">Ingresar<br/> <span
                className="align-self-center">a cibercolegios</span></h1>
              {this.state.errorMessage ?
                <CiberAlerts error={this.state.errorMessage} callBack={handleShow}/> :
                null
              }
              <form className="form-signin">
                <DocumentTypes handleChange={this.handleChange} documentType={this.state.documentType} label="Tipo de Documento"/>
                <br/>
                <label>Número de Documento</label>
                <div className="form-label-group">
                  <input type="text"
                    id="document"
                    name="document"
                    className="form-control"
                    placeholder="Número de Documento"
                    required
                    onChange={e => this.handleChange(e)}
                    value={this.state.document}
                    autoFocus/>
                </div>
                <br/>
                <label>Contraseña</label>
                <div className="form-label-group">
                  <input type="password"
                    id="password"
                    name="password"
                    className="form-control"
                    placeholder="Contraseña"
                    required
                    onChange={e => this.handleChange(e)}
                    value={this.state.password}
                  />
                </div>
                <hr/>

                <button className="btn btn-lg btn-primary btn-block" type="button"
                  disabled={loading || (!this.state.password || !this.state.document || !this.state.documentType)}
                  onClick={loginForm}>Ingresar {loading ? <Spinner animation="border" role="status">
                  <span className="sr-only">Loading...</span>
                </Spinner> : ""}
                </button>
                <PasswordModal />
              </form>
            </div>
          </div>)
        }}
      </Mutation>
    )
  }
}

export default SignInForm;
